export default "__VITE_ASSET__DZoY5yoB__"